import axios from 'axios'

export default {
    getQuestions(quizId) {
        return axios.get('/quiz-review', {
            params: {
                quiz_id: quizId
            }
        })
    }
}
